import React from 'react';

// Full-width grid cell wrapping the content of a single wizard step.
export default function StepShell({ children }) {
  return (
    <div className="row">
      <div className="col-md-12">{children}</div>
    </div>
  );
}
